/**
 * 주간 시간표 치수 — 여러 파일이 같은 값을 써야 해서 한 곳에 둔다(2026-09-11).
 * 예전에는 TimeGridView·useCalendarDnD·useCalendarCreateDnD 가 48 을 각자 적어 두어,
 * 한 곳만 바꾸면 블록 위치와 드래그 좌표가 어긋날 수 있었다.
 */

/** 1시간 칸의 세로 높이(px). 2026-09-11 사용자 지시로 48 에서 60 으로 — 1분이 1px 이 된다. */
export const HOUR_PX = 60;

/**
 * 주간을 열었을 때 날짜 머리 바로 아래 오는 시각(시) — **근무 정책을 받기 전 · 못 받았을 때의 자리**.
 * 2026-09-11 사용자 지시로 08시였다가, 2026-10-23 사용자 지시 「웹도 근무 시작 시간으로」로
 * 근무 시작 시각을 따르게 되면서 물러서는 값은 앱(지시 18)과 같은 09시가 됐다 — `ALL_DAY_FALLBACK.start` 와 같다.
 */
export const WEEK_INITIAL_TOP_HOUR = 9;

/** `HH:mm` → 시간표 세로 위치(px). 그 시각의 가로줄이 맨 위에 온다. */
export function topForHhmm(hhmm: string): number {
  const h = Number(hhmm.slice(0, 2));
  const m = Number(hhmm.slice(3, 5));
  return (h + m / 60) * HOUR_PX;
}
